// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footerContent":"footer_footerContent__duq4o","footerTitle":"footer_footerTitle__IHMne","footerName":"footer_footerName__h7qke"};